import { VolumeDown, VolumeMute, VolumeOff, VolumeUp } from '@mui/icons-material'
import { VOLUME_MARKS } from '../pages/Home/Instruments/Instruments'

const ICON_SIZE = 16

export const VolumeIcon = ({ value }: { value: number }) => {
    if (value === VOLUME_MARKS[0].value) {
        return <VolumeOff sx={{ fontSize: ICON_SIZE }} />
    }
    if (value === VOLUME_MARKS[1].value) {
        return <VolumeMute sx={{ fontSize: ICON_SIZE }} />
    }
    if (value === VOLUME_MARKS[4].value) {
        return <VolumeDown sx={{ fontSize: ICON_SIZE }} />
    }
    if (value >= VOLUME_MARKS[5].value) {
        return <VolumeUp sx={{ fontSize: ICON_SIZE }} />
    } else {
        return <VolumeDown sx={{ fontSize: ICON_SIZE }} />
    }
}
